<template>
    <div class="mr-2">
        <v-btn color="primary"
                small
                flat
                outline
                class="botao-menu"
                id="processoDigital"
               :href="processoVirtualUrl"
               target="_blank">
            Processo Digital
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'AcoesProcessoDigital',
    props: {
        processoVirtualUrl:  {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped lang="stylus">
    .botao-menu
        text-transform capitalize
        margin 0
</style>